export default __webpack_public_path__ + "static/media/cruceros.e44a769a.svg";